<template>
  <div>
    <!-- Users Table -->
    <b-table
      v-if="selectedClient"
      :items="clientUsers"
      :fields="fields"
      sort-by="email"
      responsive
      small
      hover
      striped
      show-empty
      :per-page="paging.pageSize"
      :current-page="paging.pageNo"
    >
      <template #cell(createdDate)="data">
        <span>{{ data.item.createdDate | date }}</span>
      </template>

      <template #cell(lastLoginDate)="data">
        <span>{{ data.item.lastLoginDate | dateTime }}</span>
      </template>

      <template #cell(salesName)="data">
        <span>{{ selectedClientObject ? selectedClientObject.salesName : '-' }}</span>
      </template>

      <template #cell(action)="data">
        <div v-if="data.item.userCode !== currentUser.userCode">
          <b-button
            title="Reset Password"
            variant="info"
            size="sm"
            @click.stop="$emit('reset-password', data.item.userCode)"
          >
            <feather-icon icon="KeyIcon"></feather-icon>
          </b-button>
          <edit-button class="ml-1" @click.stop="$emit('edit', data.item.userCode)"></edit-button>
          <delete-button
            class="ml-1"
            :content="data.item.isActive ? `Deactivate` : `Activate`"
            :variant="data.item.isActive ? `danger` : `success`"
            icon="PowerIcon"
            @click.stop="$emit('toggle-active', data.item)"
          ></delete-button>
        </div>
        <div v-else>
          <edit-button class="ml-1" @click.stop="$emit('edit', data.item.userCode)"></edit-button>
        </div>
      </template>
    </b-table>

    <!-- Empty State -->
    <div v-if="!selectedClient" class="text-center text-muted py-5">
      <feather-icon icon="UsersIcon" size="48" class="mb-2" />
      <p>Please select a client to view users</p>
    </div>

    <div v-if="selectedClient && (!clientUsers || clientUsers.length === 0)" class="text-center text-muted py-5">
      <feather-icon icon="UsersIcon" size="48" class="mb-2" />
      <p>No users found for this client</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientView",
  props: {
    selectedClient: {
      type: [String, Number],
      default: undefined,
    },
    selectedClientObject: {
      type: Object,
      default: null,
    },
    clientUsers: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentUser: {
      type: Object,
      required: true,
    },
    paging: {
      type: Object,
      required: true,
      default: () => ({
        pageNo: 1,
        pageSize: 20,
      }),
    },
  },
  computed: {
    fields() {
      const baseFields = [
        { key: `email`, label: `Email`, sortable: true },
        { key: `roleCode`, label: `Role`, class: `text-nowrap`, sortable: true },
        { key: `createdDate`, label: `Created`, class: `text-right text-nowrap` },
        { key: `lastLoginDate`, label: `Last Login`, class: `text-right text-nowrap` },
      ];

      // Add sales column only for ADM users
      if (this.currentUser.roleCode === 'ADM') {
        baseFields.push({ key: `salesName`, label: `Sales`, class: `text-nowrap`, sortable: false });
      }

      baseFields.push({ key: `action`, label: `Action`, class: `text-right action-column` });

      return baseFields;
    },
  },
};
</script>
